import { useEffect, useState } from "react";
import { query, orderByChild, equalTo, onValue } from "firebase/database";
import { useAuth } from "../contexts/AuthContext";
import { jobRequestsDbRef } from "../utils/dbRefs";

const useJobsCount = () => {
    const [count, setCount] = useState(0);
    const [jobCountLoading, setJobsCountLoading] = useState(true);
    const { currentUser } = useAuth();

    useEffect(() => {
        if (!currentUser?.uid) {
            setCount(0);
            setJobsCountLoading(false);
            return;
        }

        setJobsCountLoading(true);

        const jobsQuery = query(
            jobRequestsDbRef,
            orderByChild("shop/uid"),
            equalTo(currentUser.uid)
        );

        const unsubscribe = onValue(jobsQuery, (snapshot) => {
            const data = snapshot.val();

            if (data) {
                const receivedJobsCount = Object.values(data).filter(
                    (job) => job.status === "received"
                ).length;

                setCount(receivedJobsCount);
            } else {
                setCount(0);
            }

            setJobsCountLoading(false);
        });

        return () => unsubscribe();
    }, [currentUser?.uid]);

    return { count, jobCountLoading };
};

export default useJobsCount;